import type { StickyType } from "@/model/stickyType";

import { BaseBoard } from "./BaseBoard";

export class ObjectivesBoard extends BaseBoard<"objectives"> {
  get possibleStickyTypes(): StickyType[] {
    return [];
  }

  contextActions = {};
}
